import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { CustomDashboardsService } from '../../../my-limegear/services/my-limegear.service';
import { NoDataTypes } from '../../interfaces/no-data';
import {NavigationHelpService} from "app/modules/shared/services/navigation-help.service";
import {ICardControllerInfo} from "app/modules/shared/components/card-controller-panel/card-controller-panel.component";

export interface ITableDataItems {
    fieldId: string;
    value: string;
    type: 'string' | 'money' | 'number' | 'percent';
    style: object;
    percent?: number;
}
export interface ISimpleTableData {
    title: string;
    isDataready: boolean;
    hasData: boolean;
    urlSegment: string;
    baseUrl: string;
    hasDrilldown: boolean;
    headerItems: ITableDataItems[];
    rowItems: Array<ITableDataItems[]>;
    footerItems: ITableDataItems[];
    noDataType?: NoDataTypes;
    hasAccess: boolean;
    navFromUrl: string;
    queryParams?: object;
    showCardControllers?: boolean;
    showPercentages?: boolean;
}

@Component({
    selector: 'simple-table-card',
    templateUrl: './simple-table-card.component.html',
    styleUrls: ['./simple-table-card.component.scss'],
})
export class SimpleTableCardComponent implements OnInit, OnChanges {
    constructor(
        private customDashboardsService: CustomDashboardsService,
        private navigationHelpService: NavigationHelpService
    ) {}
    @Input() simpleCard: ISimpleTableData;
    cardControllerInfo: ICardControllerInfo;

    ngOnInit() { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.simpleCard) {
            let change = <ISimpleTableData>changes.simpleCard.currentValue;

            if (change) {
                let showCardControllers =
                    (this.customDashboardsService.hasEditPermission() &&
                        this.simpleCard.showCardControllers) ??
                    false;

                this.cardControllerInfo = {
                    cardId: change.urlSegment,
                    showCardControllers: showCardControllers,
                    cardTitle: change.title,
                }
            }
        }
    }

    dataCardClick(card: ISimpleTableData) {
        if (card.hasAccess) {
            this.navigationHelpService.navigateTo(
                [card.baseUrl, card.urlSegment],
                card.queryParams,
                true);
        }
    }
}
